import { useState } from 'react';

export default function useAppMenu() {
  const [anchorElement, setAnchorElement] = useState(null);
  const handleClick = e => {
    setAnchorElement(e?.currentTarget);
  };
  const handleClose = () => {
    setAnchorElement(null);
  };

  const handleAppClick = (e, url, windowName) => {
    window.open(url, windowName || '_blank');
    handleClose(e);
  };
  return {
    open: !!anchorElement,
    anchorElement,
    handleClick,
    handleClose,
    handleAppClick,
  };
}
